import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import { registerServiceWorker } from './serviceWorker';
import { AuthProvider2 } from 'src/contexts/AuthContext';

registerServiceWorker();

ReactDOM.render(
  <HelmetProvider>
      
        <BrowserRouter>
            <AuthProvider2>
            <App />
            </AuthProvider2>
        </BrowserRouter>
        
  </HelmetProvider>,
  document.getElementById('root')
);

